import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { signIn as slidersign } from "../features/counterSlice";


export const changePassword = createAsyncThunk(
    "auth/changePassword",
    async ({ token, formData }, { rejectWithValue }) => {
        try {
            const response = await axios.put(
                `${process.env.REACT_APP_BASE_URL}/auth/change-password`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    }
                }
            );

            if (response?.data?.status) {
                return { status: response.data.status, response: response.data.response }

            } else {

                return rejectWithValue("Check your network connection!");
            }
        } catch (error) {
            const message =
                error?.response?.data?.message || "failed.";
            toast.error(message);
            return rejectWithValue(message);
        }
    }
);



export const join = createAsyncThunk(
    "auth/join",
    async ({ token, password, confirmPassword }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/auth/join`,
                { password, confirmPassword },
                {
                    params: {
                        token
                    }
                }
            );

            if (response?.data?.status) {
                return response.data
            } else {

                return rejectWithValue("Check your network connection!");
            }
        } catch (error) {
            const message =
                error?.response?.data?.message || "failed.";
            // toast.error(message);
            return rejectWithValue(message);
        }
    }
);



export const signIn = createAsyncThunk(
    "auth/signIn",
    async ({ email, password, rememberMe, navigate, setToken }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/auth/signin`,
                { email, password, rememberMe }
            );

            if (response?.data?.status) {

                const userData = response.data.response;

                setToken("isVerified", userData.isVerified, {
                    path: "/",
                    expires: new Date(Date.now() + 4 * 24 * 60 * 60 * 1000),
                });

                setToken("userData", JSON.stringify(userData), {
                    path: "/",
                    expires: new Date(Date.now() + 4 * 24 * 3600 * 1000),
                });

                setToken("token", JSON.stringify(userData.token), {
                    path: "/",
                    expires: new Date(Date.now() + 4 * 24 * 3600 * 1000),
                });

                toast.success("Sign-in successful!");


                return userData;
            } else {
                toast.error("Signup Failed!");
                return rejectWithValue("Check your network connection!");
            }
        } catch (error) {
            console.log(error);
            const message =
                error?.response?.data?.message || "Server is down, we will be back soon.";
            toast.error(message);
            return rejectWithValue(message);
        }
    }
);

export const signUp = createAsyncThunk(
    "auth/signUp",
    async ({ name, email, password, ref }, { rejectWithValue }) => {
        try {
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/auth/signup`,
                { name, email, password },
                {
                    params: {
                        ref
                    }
                }
            );

            if (response?.data?.status) {
                toast.success(response.data.response);
                return response.data;
            } else {
                toast.error("Signup Failed!");
                return rejectWithValue("Signup Failed!");
            }
        } catch (error) {
            toast.error(error.response.data.message || 'Something went wrong Try again Later');
            return rejectWithValue(error.response.data.message);
        }
    }
);



export const signOut = createAsyncThunk(
    "auth/signOut",
    async ({ navigate, removeTokenCookie }) => {

        removeTokenCookie("token", { path: "/" });
        removeTokenCookie("userData", { path: "/" });
        localStorage.removeItem("persist:root");
        localStorage.clear();
        sessionStorage.clear();
        // window.location.reload();



        // setTimeout(() => {
        //     navigate("/");
        // }, 500);

        return null;
    }
);


export const me = createAsyncThunk(
    "auth/me",
    async ({ token }, { rejectWithValue }) => {
        try {
            console.log(token)
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/auth/me`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Bearer ${token}`,
                    },
                }
            );
            // console.log(response)
            if (response?.data?.status && response?.data?.response) {
                // console.log(response.data.response)
                return response.data.response;

            }
            else {
                return rejectWithValue("User fetching info failed");
            }
        } catch (error) {
            // console.log(error?.response?.data?.message)
            toast(error?.response?.data?.message || error.message || "An unexpected error occurred")

            return rejectWithValue(
                error?.response?.data || error.message || "An unexpected error occurred"
            );
        }
    }
);



const authSlice = createSlice({
    name: "auth",
    initialState: {
        firstCall: true,
        user: null,
        token: null,
        isLoading: false,
        error: null,
    },
    reducers: {
        resetUser: (state) => {
            state.user = null;
            state.token = null;
            state.isLoading = false;
            state.error = null;
        },
        setToken: (state, action) => {
            state.token = action.payload;
        },
        resetToken: (state) => {
            state.token = null
        },
        setUserAvatar: (state, action) => {
            state.user = {
                ...state.user, avatar: action.payload
            };
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signIn.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(signIn.fulfilled, (state, action) => {
                state.isLoading = false;
                state.user = action.payload;
                state.token = action?.payload?.token;
            })
            .addCase(signIn.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(signUp.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(signUp.fulfilled, (state, action) => {
                state.isLoading = false;
                state.user = action.payload;
            })
            .addCase(signUp.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            })
            .addCase(signOut.fulfilled, (state) => {
                state.user = null;
                state.token = null;
            })
            .addCase(me.pending, (state) => {
                state.isLoading = true
            })
            .addCase(me.fulfilled, (state, action) => {
                state.isLoading = false
                if (state.firstCall) {
                    {
                        state.firstCall = false
                    }
                }
                state.user = action.payload
              


            })
            .addCase(me.rejected, (state, action) => {
                state.isLoading = false
                state.error = action.payload

            })
            .addCase(changePassword.pending, (state) => {
                state.isLoading = true
            })
            .addCase(changePassword.fulfilled, (state, action) => {
                state.isLoading = false

                toast.success(action.payload.response)
            })
            .addCase(changePassword.rejected, (state, action) => {
                state.isLoading = false

                toast.error(action.payload)
            })
            .addCase(join.pending, (state) => {
                state.isLoading = true
            })
            .addCase(join.fulfilled, (state, action) => {
                state.isLoading = false
                toast.success(action.payload.response)
            }).addCase(join.rejected, (state, action) => {
                state.isLoading = false
                toast.error(action.payload)
            })


    },
});

export const { resetUser, setToken, resetToken, setUserAvatar } = authSlice.actions

export default authSlice.reducer;
